import React from "react";
import { Nav, NavItem, NavLink, TabContent, TabPane } from "reactstrap";
import { withTranslation } from "react-i18next";
import { COMPLIANCE_SUB_TAB } from "../constants";
import CurrentPolicies from "./subTabs/CurrentPolicies";
import ArchivedPolicies from "./subTabs/ArchivedPolicies";
import ComplianceAnalytics from "./subTabs/ComplianceAnalytics";

const ComplianceDashboard = ({ t, activeSubTab, setActiveSubTab }) => {
  const subTab =
    typeof activeSubTab === "number"
      ? activeSubTab
      : COMPLIANCE_SUB_TAB.currentPolicies;
  const setSubTab = setActiveSubTab || (() => {});
  const renderSubTabs = () => (
    <Nav tabs>
      <NavItem>
        <NavLink
          className={
            subTab === COMPLIANCE_SUB_TAB.currentPolicies ? "active" : ""
          }
          onClick={() => setSubTab(COMPLIANCE_SUB_TAB.currentPolicies)}
        >
          {t("officePolicyManagement.currentPolicies")}
        </NavLink>
      </NavItem>
      <NavItem>
        <NavLink
          className={
            subTab === COMPLIANCE_SUB_TAB.archivedPolicies ? "active" : ""
          }
          onClick={() => setSubTab(COMPLIANCE_SUB_TAB.archivedPolicies)}
        >
          {t("officePolicyManagement.archivedPolicies")}
        </NavLink>
      </NavItem>
      <NavItem>
        <NavLink
          className={
            subTab === COMPLIANCE_SUB_TAB.complianceAnalytics ? "active" : ""
          }
          onClick={() => setSubTab(COMPLIANCE_SUB_TAB.complianceAnalytics)}
        >
          {t("officePolicyManagement.complianceAnalytics")}
        </NavLink>
      </NavItem>
    </Nav>
  );

  return (
    <>
      {renderSubTabs()}
      <TabContent  activeTab={subTab}>
        <TabPane tabId={COMPLIANCE_SUB_TAB.currentPolicies}>
          <CurrentPolicies isActive={subTab === COMPLIANCE_SUB_TAB.currentPolicies} />
        </TabPane>
        <TabPane tabId={COMPLIANCE_SUB_TAB.archivedPolicies}>
          <ArchivedPolicies isActive={subTab === COMPLIANCE_SUB_TAB.archivedPolicies} />
        </TabPane>
        <TabPane tabId={COMPLIANCE_SUB_TAB.complianceAnalytics}>
          <ComplianceAnalytics />
        </TabPane>
      </TabContent>
    </>
  );
};

export default withTranslation()(ComplianceDashboard);
